import {
  COMPTA_CHEQUES_API,
  COMPTA_PRELEV_API,
  COMPTA_VIREMENTS_API,
} from '../constants/Constants'

function getPrelevements(
  sortType,
  sortOrder,
  currentPage,
  itemsPerPage,
  count,
) {
  return {
    name: 'prélèvements',
    method: 'get',
    url: `${COMPTA_PRELEV_API}?orderBy=${sortType}&way=${sortOrder}&page=${currentPage}&itemsPerPage=${itemsPerPage}&count=${count}`,
    headers: {
      accept: 'application/ld+json',
    },
  }
}

function getVirements(
  sortType,
  sortOrder,
  currentPage,
  itemsPerPage,
  count,
) {
  return {
    name: 'virements',
    method: 'get',
    url: `${COMPTA_VIREMENTS_API}?orderBy=${sortType}&way=${sortOrder}&page=${currentPage}&itemsPerPage=${itemsPerPage}&count=${count}`,
    headers: {
      accept: 'application/ld+json',
    },
  }
}

function getCheques(
  sortType,
  sortOrder,
  currentPage,
  itemsPerPage,
  count,
) {
  return {
    name: 'chèques',
    method: 'get',
    url: `${COMPTA_CHEQUES_API}?orderBy=${sortType}&way=${sortOrder}&page=${currentPage}&itemsPerPage=${itemsPerPage}&count=${count}`,
    headers: {
      accept: 'application/ld+json',
    },
  }
}

export default {
  getPrelevements,
  getVirements,
  getCheques,
}
